import React from 'react';
import Header from './header';
import Ionicon from 'react-ionicons';

const Contact = () => {
  return (
    <div id="contact" className="container contact">
      <Header title="Contact Me" />
      <p className="text-center lead mono">
        Questions? Email me at {' '}
        <span className="pink-underline">
          <a href="mailto:jeffcomertennis@gmail.com" target="_top">
          jeffcomertennis@gmail.com
          </a>
        </span>
      </p>
      <p className="text-center small-text mono"></p>
      <p className="text-center">
        <div className="media-icons">
          <a
            href="https://github.com/jsc215"
            target="_blank"
            rel="noopener noreferrer">
            <Ionicon icon="ion-social-octocat" fontSize="50px" color="black" />
          </a>
          <a
            href="https://www.linkedin.com/in/jeffcomertennis"
            target="_blank"
            rel="noopener noreferrer">
            <Ionicon
              icon="ion-social-linkedin"
              fontSize="50px"
              color="black" />
          </a>
        </div>
      </p>
    </div>
  );
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/contact.js